import { useCallback } from "react";
import styled from "styled-components/macro";
import { MemberType } from "../../types";
import { UserAvatar } from "../Avatar";
import { CloseIcon } from "../Close/CloseIcon";

interface SelectedMemberProps {
  member: MemberType;
  onClick: (member: MemberType) => void;
}

export function SelectedMember({ member, onClick }: SelectedMemberProps) {
  const handleClick = useCallback(() => {
    onClick(member);
  }, [onClick, member]);

  return (
    <Button type="button" onClick={handleClick} title={member.name}>
      <UserAvatar size="xxxs" user={member} />
      <Name>{member.name}</Name>
      <CloseContainer>
        <CloseIcon />
      </CloseContainer>
    </Button>
  );
}

const Button = styled.button`
  cursor: pointer;
  border: 1px solid ${(p) => p.theme.colors.borders.separator};
  border-radius: 8px;
  background-color: ${(p) => p.theme.colors.backgrounds.main};
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 1px 5px 1px 3px;
  box-sizing: border-box;
  max-width: 280px;
`;

const Name = styled.span`
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CloseContainer = styled.div`
  flex: 0 0 auto;
  padding: 2px;
`;
